import React from "react";
import { AlertColor } from "@mui/material";

export interface CustomizeBackOverride {
  label: string;
  onBack: () => void;
}

export interface BrandSetupWizardContextValue {
  usesExternalGivingPage: boolean;
  customizeStepIndex: number;
  onExit?: () => void;
  showSnackbar?: (message: string, severity?: AlertColor) => void;
  customizeBackOverride: CustomizeBackOverride | null;
  setCustomizeBackOverride: (override: CustomizeBackOverride | null) => void;
}

const noop = () => {};

export const BrandSetupWizardContext =
  React.createContext<BrandSetupWizardContextValue>({
    usesExternalGivingPage: false,
    customizeStepIndex: 2,
    customizeBackOverride: null,
    setCustomizeBackOverride: noop,
  });

export const useBrandSetupWizardContext = (): BrandSetupWizardContextValue =>
  React.useContext(BrandSetupWizardContext);
